var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
}


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.extrassplash = {
	init: function(overlay) {
		site.extrassplash.show(overlay);
		$('.extrassplash__close').on('click', site.extrassplash.hide);
	},
	create: function(element) {
		var title = element.parents('.item').find('h3').text();

		var contentData = '';

		var overlay = '<div class="extrassplash__overlay animated fadeIn"></div>',
			content = '<div class="extrassplash__content">'+contentData+'</div>',
			close = '<div class="extrassplash__close">X</div>',
			window = '<div class="extrassplash__window animated bounceInDown">'+close+content+'</div>',
			splash = overlay+window;
		return splash;


	//	$('.extrassplash__overlay .extrassplash__content').load(href);
	},
	show: function(overlay) {
		if ($('.extrassplash__overlay').length === 0) {
			$('body').addClass('modal-open').append(site.extrassplash.create(overlay));
		}
		$('.extrassplash__overlay').removeClass('fadeOut').addClass('fadeIn');
		$('.extrassplash__window').removeClass('bounceOutUp').addClass('bounceInDown');
	},
	hide: function() {
		$('.extrassplash__overlay').removeClass('fadeIn').addClass('fadeOut');
		$('.extrassplash__window').removeClass('bounceInDown').addClass('bounceOutUp');
		$('body').removeClass('modal-open');
	}
};

site.frontpage = {
	init: function () {
		if($('#owl-banner .item').length > 1) {
			site.owl.init('#owl-banner .items', {
				loop: false,
				dots:true,
				nav: false,
				items:1,
				navText: ["",""],
				stopOnHover: true,
				autoplay: true,
				autoplayTimeout: 8000,
				autoplayHoverPause: true,
				animateOut: 'fadeOut',
				animateIn: 'fadeIn'
			});
		}
		$('.bannerDown').click(function(e) {
			e.preventDefault();
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
			documentWidth = $(document).width() -15;
			var pos = target.offset().top + target.outerHeight(true);
			if (documentWidth >= 991) {
				$('html,body').animate({scrollTop: pos}, 'slow');
			}
			else {
				$('html,body').animate({scrollTop: pos - 57}, 'slow');
			}
		});
		$('#main .box_extras_category .overlay').on('click',function(e) {
			e.preventDefault();
			//var href = $(this).find(a).attr('href');
			site.extrassplash.init($(this));
			var href = $(this).find('a').attr('href');
			$.ajax( {
				method: "GET",
				url: href,
				dataType:'html',
				success:function(html) {
					var div = $('#main .boxText',$(html));
					$('.extrassplash__content').html(div.html());

				}
			}).done(function(msg){

			});
		});
	}
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	if ($('body').is('.frontpage')) {
		site.frontpage.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$('body').is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Touch login
	$('.login').dblclick(function(e) {
		e.preventDefault();
		window.location = '/moya';
	});

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);

	site.sticky.box('body', 'scrolled', -57,0,991);

	$('#mainmenu a[href*=#]:not([href=#]):not([href=http])').click(function(e) {
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
			target = (target.length == 0) ? $('body') : target;
			documentWidth = $(document).width() -15;

			if (target.length) {
				if (documentWidth >= 991) {
					//$('html,body').stop().animate({scrollTop: target.offset().top}, 'slow');
					$('html,body').stop().animate({
						scrollTop: (target.selector == '#register') ? (target.offset().top) : target.offset().top
					}, 600, function() {
						var newHash = (target.selector !== 'body') ? target.selector : '#';
						window.location.hash = newHash;
					});
					return false;
				}
				else {
					//$('html,body').stop().animate({scrollTop: target.offset().top - 57}, 'slow');
					$('html,body').stop().animate({
						scrollTop: (target.selector == '#register') ? (target.offset().top - 57) : target.offset().top
					}, 600, function() {
						var newHash = (target.selector !== 'body') ? target.selector : '#';
						window.location.hash = newHash;
					});
					return false;
				}
			}
		}



		e.preventDefault();
		var target = $(this.hash);
		target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
		documentWidth = $(document).width() -15;
		if (documentWidth >= 991) {
			$('html,body').animate({scrollTop: target.offset().top}, 'slow');
		}
		else {
			$('html,body').animate({scrollTop: target.offset().top - 57}, 'slow');
		}
	});
});
